import { CobaltLink } from '@cae/cobalt-react/components/link';
import { CobaltIconExternalLinkOutline } from '@cae/cobalt-react/icons/outline/CobaltIconExternalLinkOutline';
import { FeedbackContent } from '@shared/components/feedback-content/FeedbackContent';
import { FEEDBACK_CONFIGS } from '@shared/components/feedback-content/FeedbackContent.utils';
import { InternalServerErrorIllustration } from '@shared/components/feedback-content/illustrations/InternalServerErrorIllustration';
import { COMMON_TICKET_URL } from '@shared/utils/support-urls/supportUrls';
import * as React from 'react';

import type { LoadErrorBlockProps } from './LoadErrorBlock.types';

const LoadErrorBlock = React.memo(
  ({
    retry,
    handleGoHome,
  }: Readonly<LoadErrorBlockProps>): React.ReactElement => {
    return (
      <FeedbackContent
        title={FEEDBACK_CONFIGS['internal-server-error'].title}
        message={
          <>
            Please try again. If the problem persists, please{' '}
            <CobaltLink href={COMMON_TICKET_URL} target="_blank" inline>
              open an IT ticket
              <CobaltIconExternalLinkOutline />
            </CobaltLink>{' '}
            .
          </>
        }
        illustration={<InternalServerErrorIllustration />}
        primaryActionLabel="Try again"
        onPrimaryAction={retry}
        secondaryActionLabel="Go to Homepage"
        onSecondaryAction={handleGoHome}
      />
    );
  }
);

LoadErrorBlock.displayName = 'LoadErrorBlock';

export { LoadErrorBlock };
